export const FAMILY_TIME_ZONE_OPTIONS = [
  { value: 'Pacific/Honolulu', label: 'Hawaii Time' },
  { value: 'America/Anchorage', label: 'Alaska Time' },
  { value: 'America/Los_Angeles', label: 'Pacific Time' },
  { value: 'America/Denver', label: 'Mountain Time' },
  { value: 'America/Phoenix', label: 'Arizona Time' },
  { value: 'America/Chicago', label: 'Central Time' },
  { value: 'America/New_York', label: 'Eastern Time' },
  { value: 'America/Puerto_Rico', label: 'Atlantic Time' },
];

export const detectFamilyTimeZone = () => {
  try {
    return (
      Intl.DateTimeFormat().resolvedOptions().timeZone ||
      'America/New_York'
    );
  } catch {
    return 'America/New_York';
  }
};

export const getFamilyTimeZoneOptions = (currentValue) => {
  if (
    !currentValue ||
    FAMILY_TIME_ZONE_OPTIONS.some(
      (option) => option.value === currentValue
    )
  ) {
    return FAMILY_TIME_ZONE_OPTIONS;
  }

  return [
    {
      value: currentValue,
      label: currentValue.replaceAll('_', ' '),
    },
    ...FAMILY_TIME_ZONE_OPTIONS,
  ];
};

export const getFamilyTimeZoneLabel = (value) =>
  getFamilyTimeZoneOptions(value).find(
    (option) => option.value === value
  )?.label || value || 'Eastern Time';
